import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div align=\"center\"><div align=\"start\" style=\"width:70%;\" class=\"mt-10\"><h1 style=\"font-size:xxx-large;\">Attribution</h1><p> We would like to thank the following image and icon providers for providing the images and icons used in our products for free. </p><ul><li><a class=\"text-blue text-decoration-none\" rel=\"noopener noreferrer\" style=\"cursor:pointer;\" href=\"https://www.freepik.com/\">Freepik </a></li><li><a class=\"text-blue text-decoration-none\" rel=\"noopener noreferrer\" style=\"cursor:pointer;\" href=\"https://www.flaticon.com/\">Flaticon</a></li></ul></div></div>", 1)

import { useI18n } from 'vue-i18n'
import HeaderComponent from '@/components/Header/HeaderComponent.vue'
import FooterComponent from '@/components/Footer/FooterComponent.vue'
import { computed } from 'vue'
import { useMeta } from 'vue-meta'

export default /*#__PURE__*/_defineComponent({
  __name: 'AttributeComponent',
  setup(__props) {

const { t } = useI18n()
useMeta(
  computed(() => ({
    title: 'Attribution',
  }))
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(HeaderComponent),
    _hoisted_1,
    _createVNode(FooterComponent, { class: "footer-here" })
  ], 64))
}
}

})